import React from 'react';

class Loader extends React.Component {
    render() {
        return (
            <span>
                <i className="fa fa-spinner fa-spin fa-3x"></i>
            </span>
        )
    }
}

export default Loader


// WEBPACK FOOTER //
// ./src/components/shared/loader.js